const SESSION_ID_KEY = "clarins_crm_line_liff_session_id";

const getCurrentPath = () => {
  if (typeof window === "undefined") return "";

  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};

const createSessionId = () => {
  if (
    typeof window !== "undefined" &&
    window.crypto &&
    window.crypto.getRandomValues
  ) {
    const randomValues = window.crypto.getRandomValues(new Uint32Array(4));
    return Array.from(randomValues, value => value.toString(16)).join("-");
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const getSessionId = () => {
  if (typeof window === "undefined" || !window.sessionStorage) return "";

  let sessionId = window.sessionStorage.getItem(SESSION_ID_KEY);
  if (!sessionId) {
    sessionId = createSessionId();
    window.sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  return sessionId;
};

const attachTrackingHeaders = config => {
  config.headers = config.headers || {};
  config.headers["X-Current-Path"] = getCurrentPath();
  config.headers["X-Session-Id"] = getSessionId();

  return config;
};

export { attachTrackingHeaders, getCurrentPath, getSessionId };
